window.Products.WallArt.ArtProduct = function() {
};
window.Products.WallArt.ArtProduct.inherits(window.Products.WallArt.WallArt);

window.Products.WallArt.ArtProduct.id = 37;
window.Products.WallArt.ArtProduct.slug = 'art-product';
window.Products.WallArt.ArtProduct.has_3d = false;
window.Products.WallArt.ArtProduct.use_variants = true;
window.Products.WallArt.ArtProduct.dpi = 300;
window.Products.WallArt.ArtProduct.no_views = true;
window.Products.WallArt.ArtProduct.rotated_variants = ['2-3','3-4','8x10','11x14','16x20','20x24'];
window.Products.WallArt.ArtProduct.magic_size = 1024;

// Method to get the correct obj to load for a product
window.Products.WallArt.ArtProduct.prototype.getObj = function(_currentObj) {
	var parts = _currentObj.split('_');
	var product = parts[0].split('-').join('');
	var suffix = parts.length == 3 ? parts[2] : null;
	var variant = parts[1].split('.')[0];
	var obj = "";
	switch(variant){
		case '1-1':
			obj = "24x24";
			break;
		case '3-2':
			obj = "30x20";
			break;
		case '4-3':
			obj = "32x24";
			break;
		case '2-3':
			obj = "30x20";
			break;
		case '3-4':
			obj = "32x24";
			break;
		case '8x10':
			obj = "10x8";
			break;
		case '10x8':
			obj = "10x8";
			break;
		case '11x14':
			obj = "14x11";
			break;
		case '14x11':
			obj = "14x11";
			break;
		case '16x20':
			obj = "20x16";
			break;
		case '20x16':
			obj = "20x16";
			break;
		case '20x24':
			obj = "24x20";
			break;
		case '24x20':
			obj = "24x20";
			break;
	}
	var out = product + '_' + obj;
	if(suffix) out += '_' + suffix;
	return out;
};

// Method to get the correct scale for a product
window.Products.WallArt.ArtProduct.prototype.getScale = function(_currentSize) {
	var scales = {
		"acrylic-print": {
			"11x14"		: 0.15,
			"16x20"		: 0.15,
			"20x24"		: 0.15,
			"14x11"		: 0.15,
			"20x16"		: 0.15,
			"24x20"		: 0.15,
			"8x10"		: 0.15,
			"10x8"		: 0.15
		},
		"canvas": {
			"11x14"		: 1.4,
			"16x20"		: 1.4,
			"20x24"		: 1.4,
			"14x11"		: 1.4,
			"20x16"		: 1.4,
			"24x20"		: 1.4,
			"8x10"		: 1.4,
			"10x8"		: 1.4
		},
		"wood-print": {
			"11x14"		: 1.4,
			"16x20"		: 1.4,
			"20x24"		: 1.4,
			"14x11"		: 1.4,
			"20x16"		: 1.4,
			"24x20"		: 1.4,
			"8x10"		: 1.4,
			"10x8"		: 1.4
		}
	};
	return (scales[this.static.slug] && scales[this.static.slug][_currentSize]) ? scales[this.static.slug][_currentSize] : null;
};

window.Products.WallArt.ArtProduct.prototype.processObjectRotation = function(obj, variant){
	var rotated = window.Products.WallArt.ArtProduct.rotated_variants.indexOf(variant) != -1;
	// Already rotated
	if(obj.rotation.z > 1 && obj.rotation.z < 2){
		// Shouldnt be
		if(!rotated){
			zRotation = new THREE.Matrix4();
			zRotation.makeRotationAxis(new THREE.Vector3(0, 0, 1).normalize(), 90 * Math.PI / 180);
			zRotation.multiply(obj.matrix);
			obj.matrix = zRotation;
			obj.rotation.setFromRotationMatrix(obj.matrix);
		}
	} 
	// Not rotated
	else {
		// Should be
		if(rotated){
			zRotation = new THREE.Matrix4();
			zRotation.makeRotationAxis(new THREE.Vector3(0, 0, 1).normalize(), -90 * Math.PI / 180);
			zRotation.multiply(obj.matrix);
			obj.matrix = zRotation;
			obj.rotation.setFromRotationMatrix(obj.matrix);
		}
	}
};

window.Products.WallArt.ArtProduct.prototype.draw_scene = function(ctx, img, data) {
	var rotated = window.Products.WallArt.ArtProduct.rotated_variants.indexOf(DesignLab.instance.variant) != -1;

	//Math it
	var x, y, width, height;
	var r = data.originalWidth / data.originalHeight;

	if(rotated){
		ctx.translate(this.parent.static.magic_size / 2, this.parent.static.magic_size / 2);
		ctx.rotate(-90 * Math.PI/180); 
		ctx.translate(- this.parent.static.magic_size / 2, - this.parent.static.magic_size / 2);
	}

	if(r > 1){
		x = 0;
		width = this.parent.static.magic_size;
		height = this.parent.static.magic_size / r;
		y = (this.parent.static.magic_size - height) / 2;
	} else {
		y = 0;
		height = this.parent.static.magic_size;
		width = this.parent.static.magic_size * r;
		x = (this.parent.static.magic_size - width) / 2;
	}

	//Draw it
	ctx.drawImage(img, 
		data.deltax*data.canvasPixelRatio,
		data.deltay*data.canvasPixelRatio,
		data.originalWidth*data.canvasPixelRatio,
		data.originalHeight*data.canvasPixelRatio,
		x,
		y,
		width,
		height
	);

	if(rotated){
		ctx.translate(this.parent.static.magic_size / 2, this.parent.static.magic_size / 2);
		ctx.rotate(90 * Math.PI/180); 
		ctx.translate(- this.parent.static.magic_size / 2, - this.parent.static.magic_size / 2);
	}
};